<template>
  <div class="app-wrapper">
    <div class="app-container vue-container">
      <LoadingOverlay v-if="this.isLoading"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {setBrandConfig} from "@/functions/setBrandConfig";
import {mapState, mapMutations} from "vuex";
import FantasyService from "@/services/fantasyService";
import {injectScript} from "@/functions/injectTellium";

export default {
  computed: {
    ...mapState(['isLoading', 'brandConfig'])
  },
  components: {
    LoadingOverlay
  },
  methods: {
    ...mapMutations(['setDeferredPrompt', 'setFeedArticles']),
    captureEvent() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.setDeferredPrompt(e)
      })
    },
    async setNewsFeed() {
      this.setFeedArticles(await FantasyService.getNews());
    },
  },
 beforeMount() {
    this.setNewsFeed();
    this.captureEvent();
    setBrandConfig();
    // Must follow setBrandConfig — the tag is Vodacom-only. Deliberately not
    // awaited: an analytics tag should never hold up the first render.
    if (this.brandConfig.brand.includes('vc')) injectScript();
  }
}
</script>

<style lang="scss">
@import "../public/globalStyles/global";

.app-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100svh;
}

.vue-container {
  position: relative;
  font-family: 'Poppins', sans-serif;
  background-image: url("assets/backgrounds/bg-main.webp");
  background-size: cover;
  height: 100svh;
  width: 100%;
  overflow-x: hidden;
}

/* Mobile: full width, same as before */
@media screen and (max-width: 767px) {
  .vue-container {
    max-width: 100%;
  }
}

/* Tablet */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .vue-container {
    max-width: 100%;
  }
}

/* Desktop */
@media screen and (min-width: 1024px) {
  .vue-container {
    max-width: 100%;
    overflow-y: auto;
  }
}

#ot-sdk-btn-floating.ot-floating-button {
  bottom: 50px !important;
  width: 30px !important;
  height: 30px !important;
}
</style>
